import {
    IFeed,
    IFeedState,
    SampleFeed, SampleFeedList,
    SampleFeedRow
} from "./types";
import { Reducer } from "redux";
import { rl } from "../banner/editor/reducers";
import * as actions from "./actions"
import { ActionType, getType } from "typesafe-actions";

export type FeedActions = ActionType<typeof actions>;

const initialFeedState: IFeedState = {
    liveFeeds: { byId: {} },
    sampleFeeds: { byId: {} },
    activeFeed: {
        id: "",
        name: "",
        preview: [],
        json: ""
    }
}

export const feedReducer: Reducer<IFeedState, FeedActions> = (
    state = initialFeedState,
    action
) => {
    switch (action.type) {
        case getType(actions.loadFeedsAsyncActions.success): {
            Object.values(action.payload.feeds.byId).forEach(feed => {
                addFeedToFeedManager(feed)
            })
            return {
                ...state,
                [action.payload.feedType]: {
                    byId: {
                        ...state[action.payload.feedType].byId,
                        ...action.payload.feeds.byId
                    }
                }
            }

        }
        case getType(actions.saveFeedAsyncActions.success): {
            const { feed } = action.payload
            addFeedToFeedManager(feed)
            return {
                ...state,
                sampleFeeds: {
                    byId: {
                        ...state.sampleFeeds.byId,
                        [action.payload.feed.id]: action.payload.feed
                    }
                }
            }
        }
        case getType(actions.setActiveFeedAction): {
            return {
                ...state,
                activeFeed: {
                    ...action.payload.feed,
                    json: getJsonPreview(action.payload.feed.preview)
                }
            }
        }
        case getType(actions.deleteFeedAsyncActions.success): {
            const { [action.payload.id]: removed, ...without } = state.sampleFeeds.byId
            return {
                ...state,
                sampleFeeds: {
                    byId: {
                        ...without
                    }
                },
                activeFeed: {
                    id: "",
                    name: "",
                    json: "",
                    preview: []
                }
            }
        }

        case getType(actions.modifyingActiveFeedAction): {

            return {
                ...state,
                activeFeed: {
                    ...state.activeFeed,
                    ...action.payload.feed,
                }
            }
        }
        default:
            return state;
    }

}

export const getJsonPreview = (preview: SampleFeedList): string => {
    try {
        return JSON.stringify(preview, null, 2);
    } catch (e: any) {
        return e.toString();
    }
}

export const addFeedToFeedManager = (feed: IFeed) => {
    if (!Array.isArray(feed.preview)) {
        return
    }
    const sampleFeed = feed.preview.reduce((result: SampleFeed, item: SampleFeedRow) => {
        result[item.Id] = item;
        return result
    }, {});

    rl.SetFeed(feed.name, sampleFeed);
}